import '../../style/store/store product/SP_UserNum.css';

const SP_UserNum=({user_num})=>{
  return(
    <div className="sp-usernum">
      <div className="sp-usernum-p1">
        <div className="sp-usernum-p1-item"></div>
        <div className="sp-usernum-p1-item"></div>
        <div className="sp-usernum-p1-item"></div>
        <div className="sp-usernum-p1-item">+{user_num}</div>
      </div>
      <div className="sp-usernum-p2">
        <div className="sp-usernum-p2-title">تعداد خرید محصول</div>
        <div className="sp-usernum-p2-subtitle">بیشتر از {user_num} نفر در این آزمون شرکت خواهندکرد</div>
      </div>
    </div>
  )
}

export default SP_UserNum;